var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { FlyoutTarget, FlyoutTrigger } from '@jetshop/ui/Modal/Flyout';
import SuggestedTerm from '@jetshop/ui/Search/SuggestedTerm';
import * as React from 'react';
import styled from 'react-emotion';
import SearchAutoCompleteContainer from './SearchAutoCompleteContainer';
import t from '@jetshop/intl';
import logWarningInDev from '@jetshop/core/helpers/logWarningInDev';
const Wrapper = styled('div') `
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
`;
const SearchFieldWrapper = styled('div') `
  width: 12rem;
  position: relative;
  font-size: 16px;
  font-weight: normal;
`;
const Flyout = styled('div') `
  position: absolute;
  background: white;
  z-index: 999;
  border: 1px solid #e8e8e8;
  width: 100%;
  top: 2rem;
  left: 0;
`;
const CancelButton = styled('button') `
  font-size: 0.875rem;
  border: 0;
  background: transparent;
  color: #878787;
  margin-left: 1rem;
`;
const SearchResults = ({ term, result, loading, onClick }) => {
    return result.length > 0 ? (React.createElement("ul", { style: loading ? { opacity: 0.5 } : null }, result.map(item => (React.createElement(SuggestedTerm, { term: term, onClick: onClick, key: item.id, product: item }))))) : (!loading && (React.createElement("div", { style: { padding: '1rem' } }, t('No matches for "{term}"', { term }))));
};
const SearchField = (_a) => {
    var { initialValue, className, placeholder = '', autocompleteQuery } = _a, rest = __rest(_a, ["initialValue", "className", "placeholder", "autocompleteQuery"]);
    logWarningInDev(!autocompleteQuery, `SearchField expects a prop called 'autocompleteQuery'. Relying on a built in query in @jetshop/core is deprecated and will not work in the next major release.`);
    return (React.createElement(SearchAutoCompleteContainer, Object.assign({ autocompleteQuery: autocompleteQuery, initialValue: initialValue }, rest), searchField => (React.createElement(Wrapper, { className: className },
        React.createElement(SearchFieldWrapper, null,
            React.createElement(FlyoutTrigger, { showCover: false, id: "searchFlyout" }, ({ showTarget, hideTarget }) => (React.createElement(React.Fragment, null,
                React.createElement("input", Object.assign({ placeholder: placeholder }, searchField.getInputProps({
                    onFocus: showTarget
                }))),
                React.createElement(CancelButton, Object.assign({}, searchField.getCancelProps({ onClick: hideTarget })), t('Cancel'))))),
            React.createElement(FlyoutTarget, { id: "searchFlyout" }, flyout => searchField.isDirty &&
                !(searchField.loading && searchField.result.length === 0) &&
                searchField.isOpen &&
                flyout.isOpen && (React.createElement(Flyout, null,
                React.createElement("div", Object.assign({}, searchField.getFlyoutProps()), searchField.isDirty && (React.createElement(React.Fragment, null,
                    React.createElement(SearchResults, { term: searchField.term, result: searchField.result, onClick: flyout.hideTarget, loading: searchField.loading }))))))))))));
};
SearchField.Flyout = Flyout;
SearchField.Wrapper = SearchFieldWrapper;
SearchField.Cancel = CancelButton;
export default SearchField;
//# sourceMappingURL=SearchField.js.map